// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1rlRy","content":"GlobalSearch_content__tXK_R"};